(function($){
    function multiSlideAdaptiveHeight(slider) {
        // set our vars
        let activeSlides = [];
        let tallestSlide = 0;
        
        setTimeout(function() {
            $('.slick-track .slick-active').each(function(item) {
                activeSlides[item] = $(this).outerHeight();
            });
        
            activeSlides.forEach(function(item) {
                if (item > tallestSlide) {
                    tallestSlide = item;
                }
            });
        
            $('.slick-list').height(tallestSlide);
            $('.carousel-container').height(tallestSlide);
        }, 10);
    }
    
    var optionConstructor = function(col, scrollOptions){
        var columns = col == 'thirds' ? 3 : col == 'fourths' ? 4 : 5;
        var scrollOps = JSON.parse(scrollOptions);
        var logCons = {
            dots: false,
            centerMode: true,
            centerPadding: '60px',
            slidesToShow: columns,
            slidesToScroll: columns,
            nextArrow: '.slick-gallery-container .next',
            prevArrow: '.slick-gallery-container .previous',
            autoplay: scrollOps.autoScrolling,
            autoplaySpeed: scrollOps.scrollDelay,
            speed: scrollOps.scrollSpeed,  
            responsive: [
                {
                    breakpoint: 980,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        return logCons;
    };

    $('.slick-gallery').each(function(){
        if ($(this).hasClass("carousel")){
            var elementColumn = this.getAttribute("slick-columns");
            var scrollOptions = this.getAttribute("scroll-options"); 
            $(this)
            // .on('init', function(slick) {
            //     console.log(0);
            //     multiSlideAdaptiveHeight(this);
            // })
            // .on('beforeChange', function(slick, currentSlide, nextSlide) {
            //     console.log(1);
            //     multiSlideAdaptiveHeight(this);
            // })
            .slick(optionConstructor(elementColumn, scrollOptions));
        }
    });

    // $(window).on('resize', function() {
    //     $('.slick-gallery').each(function(){
    //         if ($(this).hasClass("carousel")){
    //             console.log(2);
    //             multiSlideAdaptiveHeight(this);
    //         }
    //     });
    // });

})(jQuery);